module.exports = __webpack_public_path__ + "img/icon_notice.a9c0da8f.png";